export default 'not-supported-browser';
